import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { UrlService } from "../../core/services/UrlService"
import { CMSCampaign } from "../model/CMSCampaign"
import date from "../../core/utils/date"

export const useCmsCampaign = (slug: string) => {
    const { cmsData } = useStaticQuery(graphql`
        query {
            cmsData(name: { eq: "campaigns" }) {
                data
            }
        }
    `)

    const campaigns = JSON.parse(cmsData.data).map(x => new CMSCampaign(x))
    const campaign: CMSCampaign = campaigns.find(x => x.slug === slug)

    const layoutConfig = {
        launchDate: campaign?.startDate ? date.hktime(campaign.startDate) : null,
        endDate: campaign?.endDate ? date.hktime(campaign.endDate) : null,
        endHref: campaign?.redirectWhenEventEnd,
        removeNav: !campaign?.shouldShowHeader,
        removeFooter: !campaign?.shouldShowFooter,
        requirePassword: campaign?.requirePassword
            ? campaign.password
            : undefined,
    }

    const seoConfig = {
        title: campaign?.seoTitle,
        description: campaign?.seoDescription,
        ogImage: campaign?.seoImageUrl
            ? UrlService.getLocalImageUrl(campaign?.seoImageUrl)
            : undefined,
        shouldTitleSkipFindDocPostfix: campaign?.seoShouldSkipPostfix,
        noIndex: campaign?.noIndex,
    }
    
    const dateRangeString = `${
        campaign?.startDate
            ? layoutConfig.launchDate?.format("YYYY年MM月DD日")
            : "即日起"
    } ${
        campaign?.endDate
            ? "至 " + layoutConfig.endDate?.format("YYYY年MM月DD日")
            : ""
    }`

    return {
        campaign,
        layoutConfig,
        seoConfig,
        dateRangeString,
    }
}
